export class IdName {
  id: number;
  name?: string;
  code?: string;
  isDefault?: boolean;
}

export class IdNameString {
  id: string;
  name?: string;
  code?: string;
  isDefault?: boolean;
}
